import { Component } from '@angular/core';

@Component({
    selector: 'app-lovable-mobile-bottom-nav',
    templateUrl: './lovable-mobile-bottom-nav.component.html',
    styleUrls: ['./lovable-mobile-bottom-nav.component.css'],
})
export class LovableMobileBottomNavComponent {
    readonly items: { icon: string; active?: boolean; badge?: number }[] = [
        { icon: 'home', active: true },
        { icon: 'explore' },
        { icon: 'notifications', badge: 3 },
        { icon: 'messages' },
        { icon: 'profile' },
    ];
}
